import { OrderTicketEntity, TradeTicketEntity } from "@goodfill/domain-entities";
import { Amount, asAmount } from "@goodfill/domain-properties";
import { orderTicketApiToModel, tradeTicketApiToModel } from "@goodfill/models-typescript";
import { PortfolioCustomTradeTicketListItem } from "./doPortfolioCustomTradeTicketList";

export interface PortfolioTradeTicket extends TradeTicketEntity {
  tradeValue: Amount;
  settlementValue: Amount;
  orderTicket: OrderTicketEntity;
}

export function convertApiToPortfolioTradeTicket(api: PortfolioCustomTradeTicketListItem): PortfolioTradeTicket {
  const tradeTicketEntity = tradeTicketApiToModel(api);
  const tradeValue = asAmount(tradeTicketEntity.amount.mul(tradeTicketEntity.bondPrice));
  const accruedInterestValue = tradeTicketEntity.accruedInterest.mul(tradeTicketEntity.amount);
  const settlementValue = asAmount(
    tradeValue.plus(accruedInterestValue).plus(tradeTicketEntity.finalCommissionAmount),
  );

  return {
    ...tradeTicketEntity,
    orderTicket: orderTicketApiToModel(api.orderTicket),
    tradeValue,
    settlementValue: settlementValue,
  };
}
